import { Component, EventEmitter, Input, Output, signal } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { DxProgressBarModule } from "devextreme-angular";
import { sntTranslate } from "src/app/support/translate";

@Component({
  standalone: true,
  selector: "snt-progress-bar",
  imports: [DxProgressBarModule],
  templateUrl: "progress-bar.component.html",
  styleUrl: "progress-bar.component.scss"
})
export class ProgressBarComponent {
  @Input()
  title!: string;

  @Input()
  subTitle?: string;

  @Input()
  allSteps: number = 0;

  @Input()
  onAllStepsCompleted: VoidFunction = () => void 0;

  @Output()
  increase = new EventEmitter<number>();

  counter = signal<number>(0);

  constructor() {
    this.increase.subscribe((step) => {
      this.counter.update((counter) => (counter += step));
    });
  }

  format(ratio: number): string {
    const progress = Math.round(ratio * 100);
    return sntTranslate(marker("Operazione in corso: [progress]%"), {
      progress
    });
  }

  onComplete(): void {
    setTimeout(() => {
      this.onAllStepsCompleted();
    }, 1000);
  }
}
